// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as ReactModal from "react-modal";
import * as CountryContext from "../../../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as ButtonUtils$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/ButtonUtils.bs.js";
import * as TableComponent$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/table/TableComponent.bs.js";
import * as TicketingOrderRepoManager from "../../../../../app/order/repo/order/TicketingOrderRepoManager.bs.js";
import * as RoundedPrimaryButton$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/RoundedPrimaryButton.bs.js";
import * as FetchLoadableViewMapper$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/FetchLoadableViewMapper.bs.js";

var customStyle = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    minWidth: "50%"
  }
};

function reducer(_state, action) {
  if (action.TAG === /* SetPaymentDetails */0) {
    return {
            paymentDetails: {
              TAG: /* Live */1,
              _0: action._0
            }
          };
  } else {
    return {
            paymentDetails: {
              TAG: /* Error */2,
              _0: action._0
            }
          };
  }
}

function getColumnsSchema(param) {
  return {
          hd: {
            column: {
              TAG: /* Text */0,
              _0: "Amount"
            },
            accessor: (function (paymentDetail) {
                return {
                        TAG: /* Text */0,
                        _0: String(paymentDetail.amount)
                      };
              })
          },
          tl: {
            hd: {
              column: {
                TAG: /* Text */0,
                _0: "Created At"
              },
              accessor: (function (paymentDetail) {
                  return {
                          TAG: /* Text */0,
                          _0: paymentDetail.created_at
                        };
                })
            },
            tl: {
              hd: {
                column: {
                  TAG: /* Text */0,
                  _0: "Status"
                },
                accessor: (function (paymentDetail) {
                    return {
                            TAG: /* Text */0,
                            _0: paymentDetail.status
                          };
                  })
              },
              tl: {
                hd: {
                  column: {
                    TAG: /* Text */0,
                    _0: "Admin Email"
                  },
                  accessor: (function (paymentDetail) {
                      return {
                              TAG: /* Text */0,
                              _0: paymentDetail.admin_email
                            };
                    })
                },
                tl: /* [] */0
              }
            }
          }
        };
}

function InstaMojoModal(Props) {
  var orderId = Props.orderId;
  var toggleModal = Props.toggleModal;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var match$1 = React.useReducer(reducer, {
        paymentDetails: {
          TAG: /* Loading */0,
          _0: undefined
        }
      });
  var dispatch = match$1[1];
  var getTicketFormInfo = function (orderId) {
    var TicketingOrderRepo = TicketingOrderRepoManager.getTicketingOrderRepo(undefined);
    return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                  return Curry._2(TicketingOrderRepo.fetchInstaMojoDetails, orderId, country);
                }), (function (paymentDetails) {
                  return Curry._1(dispatch, {
                              TAG: /* SetPaymentDetails */0,
                              _0: paymentDetails
                            });
                }), (function (error) {
                  return Curry._1(dispatch, {
                              TAG: /* SetPaymentDetailsError */1,
                              _0: error
                            });
                }));
  };
  React.useEffect((function () {
          getTicketFormInfo(orderId);
          
        }), []);
  return React.createElement(ReactModal, {
              isOpen: true,
              onRequestClose: (function (param) {
                  return Curry._1(toggleModal, undefined);
                }),
              style: customStyle,
              ariaHideApp: false,
              shouldCloseOnOverlayClick: false,
              children: null
            }, React.createElement("h2", {
                  className: "text-styling-header font-size-18 u-bottom-border u-padding-bottom-small"
                }, "Order Instamojo Payments"), React.createElement(FetchLoadableViewMapper$Catalyst.make, {
                  loadableData: match$1[0].paymentDetails,
                  children: (function (paymentDetails) {
                      return React.createElement(TableComponent$Catalyst.make, {
                                  columns: getColumnsSchema(undefined),
                                  rowData: paymentDetails.instamojo_payment_records,
                                  className: "order-table"
                                });
                    })
                }), React.createElement("div", {
                  className: "modal-footer"
                }, React.createElement(RoundedPrimaryButton$Catalyst.make, {
                      buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                            TAG: /* Text */0,
                            _0: "Close"
                          }, undefined, (function (param) {
                              return Curry._1(toggleModal, undefined);
                            }), undefined, undefined, undefined, undefined, undefined, undefined, undefined)
                    })));
}

var make = InstaMojoModal;

export {
  customStyle ,
  reducer ,
  getColumnsSchema ,
  make ,
  
}
/* react Not a pure module */
